import { render, staticRenderFns } from "./DataDisplayBox.vue?vue&type=template&id=02133d8d&scoped=true&"
import script from "./DataDisplayBox.vue?vue&type=script&lang=ts&"
export * from "./DataDisplayBox.vue?vue&type=script&lang=ts&"
import style0 from "./DataDisplayBox.vue?vue&type=style&index=0&id=02133d8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02133d8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VRow})
